import React from 'react';
import styles from './index.module.scss';

export default function LayoutWrapper({ children = null }) {
  return <div className={styles.container}>{children}</div>;
}
